import { Observable, of, from, throwError } from 'rxjs';
import { HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { EmpusaFakeBackend } from '@empusa/empusa-core';
import { MICROAPPFAKEDATABASE } from './fake.database';
import { Notifications } from '../client/dto/notifications';

/**
 * This is CRUD example for the Generic Fake Backend
 */
export class NotificationsFakeBackend extends EmpusaFakeBackend {
    microappFakeData = MICROAPPFAKEDATABASE;

    handleRoute(url: string, method: string, headers, body, database: any): Observable<HttpEvent<any>> {
        switch (true) {
            case url.endsWith('notificationss') && method === 'GET':
                return this.getGenerics(database);
            case url.match(/\/generics\/.*$/) && method === 'DELETE':
                return this.deleteGeneric(database, EmpusaFakeBackend.idFromUrl(url));
            case url.match(/\/generics\/.*$/) && method === 'GET':
                return this.getGenericById(database, EmpusaFakeBackend.idFromUrl(url));
            case url.match(/\/generics\/.*$/) && method === 'PUT':
                return this.updateGeneric(database, body, EmpusaFakeBackend.idFromUrl(url));
            case url.endsWith('generics') && method === 'POST':
                return this.createGeneric(database, body);
            default:
                //otherwise, we don't handle this request
                return null;
        }

    }

    createGeneric(database, body) {
        let generic: Notifications = JSON.parse(body);
        generic.sid = "" + Date.now();
        let generici = {
            sid: generic.sid,
            title: generic.title
        }

        database.generics.push(generici);
        return EmpusaFakeBackend.ok(generici);
    }

    getGenerics(database): Observable<HttpResponse<Notifications[]>> {
        let result: Notifications[] = [];
        //creating generics object
        database.generics.forEach((x) => {
            let generic: Notifications = new Notifications();
            generic.sid = x.sid;
            generic.title = x.title;
            result.push(generic);
        });
        return EmpusaFakeBackend.ok(result);
    }

    getGenericById(database, sid) {
        const generici = database.generics.find(x => x.sid == sid);
        let generic: Notifications = new Notifications();
        generic.sid = generici.sid;
        generic.title = generici.title;
        return EmpusaFakeBackend.ok(generic);
    }

    updateGeneric(database, body, sid) {
        let generic: Notifications = JSON.parse(body);
        let generici = {
            sid: generic.sid,
            title: generic.title
        }

        database.generics = database.generics.map(x => (x.sid == sid ? generici : x));
        return EmpusaFakeBackend.ok(body);
    }

    deleteGeneric(database, sid) {
        database.generics = database.generics.filter(x => x.sid !== sid);
        return EmpusaFakeBackend.ok();
    }







}